module.exports = __webpack_public_path__ + "img/layer-close.6095a6de.svg";